import { btnAddToCart } from '../components/cart';
import { laguangesComponent } from '../components/languages';
import { variantOnChange } from '../components/variants-product';
import { customSubmitNewsletter, isRegisteredUser, newsletterSubmit } from '../components/news-letters';
import { mountPredictiveSearch } from '../components/predictive-search';
import { onLoadUserData } from '../components/register-info-customer';
import { openAccordion } from '../utils/accordion';
import { toggleDataActive } from '../utils/toggle-dataset';
import { brandsTape } from '../components/brands-tape';
import { mediaQuery } from '../utils/media-query';

window.addEventListener('load', async () => {
  mountPredictiveSearch();
  onLoadUserData();

  btnAddToCart('.add-product-cart');
  btnAddToCart('.add-product-cart-upsell');
  openAccordion();

  isRegisteredUser();
  laguangesComponent('#js-localization-lang-form');
  laguangesComponent('#js-localization-lang-form-header');

  toggleDataActive('#js-button-language', '#js-localization-lang-form-header', {
    type: 'header-lang',
  });
  laguangesComponent('#js-localization-currency-form');
  toggleDataActive('#js-button-currency', '#js-list-currency');
  customSubmitNewsletter()
  mediaQuery('(max-width: 991px)', brandsTape)
});

/* carouselProductsToggle(
  '.carousel-products__slides-container',
  '#js-carousel-product-btn-1',
  '#js-carousel-product-btn-2'
); */
